


























import Vue from 'vue'
import moment from 'moment'
import seatings, { SeatingType } from '@/services/Seatings'
import Seatings from '@/services/Seatings'

export default Vue.extend({
  name: 'OwnerStaffList',
  data() {
    return {
      restaurantId: this.$router.currentRoute.params.restaurantId,
      seatings: [] as SeatingType[],
    }
  },
  async created() {
    await Seatings.deleteOldSeatings(this.restaurantId)
  },
  mounted() {
    seatings.getAllSeatings(this.$router.currentRoute.params.restaurantId, s => {
      this.seatings = s
    })
  },
  methods: {
    deleteSeating(id: string) {
      if (!confirm(this.$i18n.t('owner.accessCodes.confirm') + '')) {
        return
      }

      Seatings.deleteSeating(this.restaurantId, id)
    },
    formatDate(ms: number) {
      return moment(ms).format('DD MMMM YYYY, dddd')
    },
  },
})
